'use strict';
import accessStore from '../../services/locations/AccessStore'
import selected from '../../services/locations/SelectedLocationsStore'
import * as api from '../../services/locations/api'


/**
 * I'm deprecated pending refactor. Don't use me if you can avoid it.
 * Lots of angular controllers still need to use me so that updates are attached to angular's digest cycle
 */
angular.module('clientDashboardApp').factory('locationService', function (
  $q, $http, $log, $rootScope, userService, $cacheFactory) {


  selected.onSelectedEntityChange(value => {
    // kick angular to recognize changed location group selection
    setTimeout(() => $rootScope.$apply())
  });

  function withDigest(functionReturningPromise) {
    return (...args) => $q.resolve().then(() => functionReturningPromise(...args))
  }

  const self = {
    countLocations: withDigest(api.countLocations),

    getLocations: withDigest(api.getLocations),

    getLocation(locationId, refresh) {
      if (refresh == true) {
        $cacheFactory.get('$http').remove('/location/' + locationId);
      }
      return $http.get('/location/' + locationId, {cache: !refresh}).then(response => response.data);
    },

    getLocationsInGroup: withDigest(api.getLocationsInGroup),

    getLocationNotificationSettings: withDigest(api.getLocationNotificationSettings),

    updateNotificationSettings: withDigest(api.updateNotificationSettings),

    loadLocationGroup: (groupId) => $http
      .get('/location/group/' + groupId)
      .then((response) => response.data.locations || []),

    getSelectedGroupId() {
      return selected.legacyGroupIdOrAll
    },

    defaultGroupId() {
      return 'all-' + userService.getCurrentUser().username;
    },

    selectedGroup() {
      return selected.selectedEntity || accessStore.all[0]
    },

    setSelectedGroupId(groupId) {
      selected.setLegacyGroupId(groupId)
    },

    locationsAndGroups() {
      return accessStore.onceLoaded().then(() => {
        return {
          locations: accessStore.locations,
          groups: accessStore.groups,
          accounts: accessStore.accounts,
          all: accessStore.all
        }
      })
    },

    locationsForAccount(accountId) {
      return $http.get('/location/account/' + encodeURIComponent(accountId))
        .then(response => response.data.locations);
    },

    formatAddress(address) {
      return [
        address.street,
        address.suite,
        address.city,
        address.state,
        address.postalCode,
        address.country,
      ].filter(x => !!x).join(', ');
    },

    formatLocation(location) {
      var locationSummary = location.businessName || location.busName;
      var addressSummary = self.formatAddress(location.businessAddress || location.address);

      if (addressSummary) {
        locationSummary += ', ' + addressSummary;
      }
      return {
        isDeleted: location._deleted !== undefined,
        locationId: location.locationId || location.id,
        accountId: location.accountId,
        summary: locationSummary,
        notActiveLocation: location["_deleted"] !== undefined,
        // Used to determine $dirty locations where location.isDeleted has been changed
        originalNotActiveLocation: location["_deleted"] !== undefined
      };
    },

    locationSummary(locationId) {
      return this.getLocation(locationId, false).then(this.formatLocation);
    },

  }
  return self

});
